import { LOGO } from '../shared/logo';

export const Logo = (state = LOGO, action) => {
    switch(action.type) {
        default:
            return state;
    }    
};